import { useCallback } from 'react';
import useAccessToken from './useAccessToken';

export default function useFilesUrlWithToken() {
  const { data: accessToken } = useAccessToken();

  /**
   * Used to access protected file and images
   * @param src original file url
   * @returns url with the access token as query parameter
   */
  const fileUrlWithToken = useCallback(
    (src?: string | null): string | null => {
      if (!src) {
        return null;
      }

      const url = `${src}?token=${accessToken}`;

      return url;
    },
    [accessToken],
  );

  type CropParams = {
    width?: number;
    height?: number;
    quality?: number;
    format?: 'card' | 'card-lg' | 'card-sm' | 'thumbnail' | 'thumbnail-lg' | 'thumbnail-sm' | 'cover' | 'cover-sm';
  };

  const fileUrlWithCroppingParamAndToken = useCallback(
    (url?: string, cropParams?: CropParams): string | undefined => {
      if (!url) {
        return undefined;
      }

      const { width, height, quality, format } = cropParams || {};
      const params = new URLSearchParams();

      if (format) {
        params.append('format', format);
      } else {
        if (width) params.append('w', width.toString());
        if (height) params.append('h', height.toString());
        if (quality) params.append('q', quality.toString());
      }

      if (accessToken) params.append('token', accessToken);

      return `${url}?${params.toString()}`;
    },
    [accessToken],
  );

  return {
    fileUrlWithToken,
    fileUrlWithCroppingParamAndToken,
  };
}
